import axios from 'axios'
import { Message, Loading } from 'element-ui';
import router from './router'
import globel from './global_variable'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false,minimum: 0.1 ,ease: 'ease', speed: 500 ,trickleRate: 0.02, trickleSpeed: 800 })


let loading       

function startLoading() {    
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
    })
}
function endLoading() {   
    loading.close()
}


axios.interceptors.request.use(config => {
    if(globel.loding != true){

        NProgress.start();
    }
    /*if (localStorage.eleToken)*/
    config.headers['terminaltype']  = 'pc' 
    config.headers['version']  = '1.0.0' 
    return config
}, error => {
    return Promise.reject(error)
})

axios.interceptors.response.use(response => {

    NProgress.done();
    return response
}, error => {
    NProgress.done();
    Message.error(error.response.data)
    const { status } = error.response
    if (status == 401) {
        Message.error('token值无效，请重新登录')
    }

    return Promise.reject(error)
})
    


export default axios